import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './style.css';

class UploadValidationModal extends React.Component {
  render() {
    const {
      hideUploadValidationModal,
      showUploadValidationModal,
      textModal,
    } = this.props;

    return (
      <Modal
        onHide={hideUploadValidationModal}
        show={showUploadValidationModal}
        dialogClassName={`${styles.dialog} modal-dialog margin-top-120`}
      >
        <Modal.Header>
          <Modal.Title className={styles['title-modal']}>
            Information
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>{textModal}</div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button
              type="button"
              className="btn btn-default"
              onClick={hideUploadValidationModal}
            >
              OK
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

UploadValidationModal.propTypes = {
  hideUploadValidationModal: PropTypes.func,
  showUploadValidationModal: PropTypes.func,
  textModal: PropTypes.func,
};

export default UploadValidationModal;
